if (window.location.pathname === "/acondicionamiento/periodo" || window.location.pathname === "/zona-trabajo") {

    document.addEventListener('click', function (e) {
        const btnModalFinalizarTurno = e.target.closest('#btnModalFinalizarReporteAcondicionamiento');
        if (!btnModalFinalizarTurno) return;

        const inputReporte = document.querySelector("#idReporteAcondicionamiento");
        const modalFinalizar = document.querySelector("#modalFinalizarTurnoAcondicionamiento");

        if (!inputReporte || !modalFinalizar) return;

        const inputIdEncabezado = modalFinalizar.querySelector("#idEncabezadoReporteAcondicionamientoFinalizar");

        if (!inputIdEncabezado) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan datos para finalizar el turno.", "alerta-roja");
            }
            return;
        }

        inputIdEncabezado.value = inputReporte.value || "";
    });

    document.addEventListener('submit', async function (e) {
        if (e.target.id !== 'formFinalizarTurnoAcondicionamiento') return;

        const botonActivo = e.submitter;

        if (!botonActivo || botonActivo.id !== 'btnFinalizarTurnoAcondicionamiento') {
            return;
        }

        e.preventDefault();

        const formulario = e.target;
        const modalProduccion = document.querySelector("#modalProduccionAcondicionamiento");
        const modalPadre = formulario.closest('.modal');
        const btnFinalizar = botonActivo;
        const spinner = btnFinalizar.querySelector('#spinner') || formulario.querySelector('#spinner');

        if (!formulario.checkValidity()) {
            formulario.reportValidity();
            return;
        }

        if (btnFinalizar) btnFinalizar.disabled = true;
        if (spinner) spinner.style.display = 'inline-block';

        formulario.querySelectorAll('.inputRojo').forEach(function (input) {
            input.classList.remove('inputRojo');
        });

        try {
            const formData = new FormData(formulario, botonActivo);

            const respuesta = await fetch('/api/acondicionamiento/finalizar', {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            let json = null;

            try {
                json = await respuesta.json();
            } catch (errorJson) {
                throw new Error('La respuesta del servidor no es JSON válido.');
            }

            if (!respuesta.ok || !json || !json.result) {
                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta('Error al finalizar el turno.', 'alerta-roja');
                }
                return;
            }

            const resultado = json.result;

            if (resultado.hayErrores) {
                if (Array.isArray(resultado.errores)) {
                    resultado.errores.forEach(function (error) {
                        if (typeof lanzarAlerta === 'function') {
                            lanzarAlerta(error.mensaje || 'Error de validación.', error.clase || 'alerta-roja');
                        }

                        if (error.campo) {
                            const campo = formulario.querySelector('[name="' + error.campo + '"]');
                            if (campo) campo.classList.add('inputRojo');
                        }
                    });
                }
                return;
            }

            const inputReporte = formulario.querySelector('#idEncabezadoReporteAcondicionamientoFinalizar');
            const idReporte = inputReporte ? inputReporte.value : '';
            const params = new URLSearchParams(window.location.search);

            if (modalPadre) modalPadre.classList.remove('modal--show');
            if (modalProduccion) modalProduccion.classList.remove('modal--show');

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta(resultado.mensaje || "Turno finalizado con éxito.", "alerta-verde");
            }

            if (typeof window.actualizarModalReporteAcondicionamiento === 'function' && idReporte) {
                window.actualizarModalReporteAcondicionamiento(idReporte);
            }

            if (typeof window.actualizarTablaAcondicionamientoPeriodo === 'function') {
                window.actualizarTablaAcondicionamientoPeriodo(params.get('mes'), params.get('año'));
            }
            if (typeof window.actualizarZonaTrabajo === 'function') {
                if (window.location.pathname === "/zona-trabajo") window.actualizarZonaTrabajo();
            }

        } catch (error) {
            console.error("Error:", error);

            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Error crítico al procesar la solicitud.", "alerta-roja");
            } else {
                alert("Error crítico al procesar la solicitud.");
            }

        } finally {
            if (btnFinalizar) btnFinalizar.disabled = false;
            if (spinner) spinner.style.display = 'none';
        }
    });
}
